// Module
var code = "<div class=\"ui-grid-cell-contents\">\n    <div ng-bind=\"row.entity.name\" smart-truncate></div>\n</div>\n<div class=\"ui-grid-cell-contents\">\n    <div class=\"c-button c-button--id u-ph\" ui-tether-obfuscated-copier=\"row.entity.storeId\" ng-bind=\"::grid.appScope.localeKeys.IDENTIFIER_ABBREVIATION | i18n\">\n    </div>\n</div>";
// Exports
module.exports = code;